import React from 'react';
import VehiclePathDisplay from './VehiclePathDisplay';
import { calculatePathDuration } from './utils';

// Format path name display helper
const getPathName = (path, locations) => {
  if (!path || path.length === 0) return "Undefined path";
  
  return path.map(id => {
    const loc = locations.find(l => l.id === id);
    return loc ? loc.name : id;
  }).join(" → ");
};

// Validate path data and identify missing information
const validatePathData = (pathInfo, path) => {
  if (!pathInfo) return { isValid: false, errorMessage: "Path information is missing" };
  
  // Check for essential path properties
  if (typeof pathInfo.distance !== 'number') {
    return { isValid: false, errorMessage: "Path distance information is missing" };
  }
  
  if (typeof pathInfo.pointCount !== 'number') {
    return { isValid: false, errorMessage: "Path point count information is missing" };
  }
  
  if (!path || !Array.isArray(path) || path.length < 2) {
    return { isValid: false, errorMessage: "Path must contain at least two points" };
  }
  
  return { isValid: true, errorMessage: null };
};

const PathInfo = React.memo(function PathInfo({ pathInfo, path, locations, title, className, isEmpty, connections }) {
  const { isValid, errorMessage } = validatePathData(pathInfo, path);
  
  const duration = React.useMemo(() => {
    if (!isValid || !pathInfo) return 0;
    return pathInfo.distance || 0;
  }, [isValid, pathInfo]);
  
  return (
    <div className={`path-info ${className || ''} ${!isValid ? 'error' : (!pathInfo ? 'empty' : '')}`}>
      <h5>{title}</h5>
      {isValid && pathInfo ? (
        <>
          <p className="duration-value">
            {duration > 0 ? `${duration.toFixed(1)} hours` : 'No duration data'}
          </p>
          <p>Contains {pathInfo.pointCount} points</p>
          
          {path && path.length >= 2 ? (
            <VehiclePathDisplay 
              path={path} 
              locations={locations}
              duration={duration}
              className={className}
            />
          ) : (
            <p className="no-path-data">No path data available</p>
          )}
        </>
      ) : (
        <>
          <p className="error-message">{errorMessage || `No ${isEmpty} path data`}</p>
          {errorMessage && <p className="error-hint">Please go to {className === 'auto' ? 'Auto Find Path' : 'Custom Path'} mode to create a valid path.</p>}
        </>
      )}
    </div>
  );
});

export default PathInfo; 